let selected_field = document.querySelector(`[name="properties[Choose Your Industry]"]`);
if(selected_field){
  let custom_input = document.querySelector('#enter_custom_industry');
  let put_input_data = document.querySelector('.add_field_value #choose-your-industry_field');
  
  put_input_data ? put_input_data.value = selected_field.value : '';
  
  selected_field.addEventListener('change',function(e){    
      if(selected_field.value == 'Other'){
        custom_input.classList.toggle('update_custom_industry');
        let enter_input_value = document.querySelector('#enter_custom_industry');
        if(enter_input_value){
          enter_input_value.addEventListener('change',function(e){
              put_input_data.value = enter_input_value.value;
          });
        }
      }else{
        custom_input.classList.remove('update_custom_industry');
        put_input_data.value = selected_field.value;
      }
  });

}

let product_pw_subscription = document.querySelector('.product-pw-subscription .select__select');
// if(product_pw_subscription){
//   document.querySelector('.product-pw-subscription .select__select').selectedIndex = "2";
//    if( product_pw_subscription.value == 'Advance / 2hr'){
//        product_pw_subscription.setAttribute('selected', 'selected');
//    }
// }


